import { io } from "socket.io-client";

// WABA Server Socket URL
const WABA_SOCKET_URL =process.env.REACT_APP_WABA_SERVER_URL;

let socket = null;

/**
 * Initialize Socket.IO connection
 */
export const initSocket = () => {
  if (socket?.connected) {
    return socket;
  }

  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const token = localStorage.getItem("userAccessToken");

  // Ensure we're connecting to the backend server, not frontend
  // WABA_SOCKET_URL should be the backend server URL (e.g., https://your-backend.ngrok-free.app)
  if (!WABA_SOCKET_URL) {
    console.error("REACT_APP_WABA_SERVER_URL is not set!");
    return null;
  }
  
  socket = io(WABA_SOCKET_URL, {
    path: "/socket.io",
    transports: ["websocket", "polling"],
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    reconnectionAttempts: 5,
    extraHeaders: {
      ...(token && { Authorization: `Bearer ${token}` }),
      ...(user.id && { "X-User-Id": user.id.toString() }),
    },
  });

  socket.on("connect", () => {
    console.log("🔌 Connected to chat server");
    
    // Join user room for conversation list updates
    if (user.id) {
      socket.emit("join_user_room", { userId: user.id });
    }
  });

  socket.on("disconnect", () => {
    console.log("❌ Disconnected from chat server");
  });

  socket.on("error", (error) => {
    console.error("Socket error:", error);
  });

  return socket;
};

/**
 * Get current socket instance
 */
export const getSocket = () => {
  if (!socket) {
    return initSocket();
  }
  return socket;
};

/**
 * Disconnect socket
 */
export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};

export default { initSocket, getSocket, disconnectSocket };

